import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  margin-right: 20px;
`

export { Container }
